import { ReducerFunctions } from "../../config/helper";
import {
  ForgotPassoword,
  Marketings,
  Logout,
  NewPassoword,
  Notifications,
  PriceWorker,
  Register,
  ResetPassoword,
  CreateDelegateUser,
  GetDelegateUsers,
  UpdateDelegateUser,
  Sessions,
  SelectCustomer,
  Timezone,
  UserDashboard,
  UserProfile,
  WarrentyDocs,
} from "./Action";

export const register_reducer = ReducerFunctions(Register, {});
export const timezone_reducer = ReducerFunctions(Timezone, {});
export const price_worker_reducer = ReducerFunctions(PriceWorker, {});
export const dashboard_reducer = ReducerFunctions(UserDashboard, {});
export const sessions_reducer = ReducerFunctions(Sessions, {});
export const select_customer_reducer = ReducerFunctions(SelectCustomer, {});
export const logout_reducer = ReducerFunctions(Logout, {});
export const new_password_reducer = ReducerFunctions(NewPassoword, {});
export const forgot_password_reducer = ReducerFunctions(ForgotPassoword, {});
export const reset_password_reducer = ReducerFunctions(ResetPassoword, {});
export const user_profile_reducer = ReducerFunctions(UserProfile, {});
export const notifications_reducer = ReducerFunctions(Notifications, {});
export const warrenty_docs_reducer = ReducerFunctions(WarrentyDocs, {});
export const marketing_reducer = ReducerFunctions(Marketings, {});
export const create_delegate_user_reducer = ReducerFunctions(CreateDelegateUser, {});
export const get_delegate_users_reducer = ReducerFunctions(GetDelegateUsers, {});
export const update_delegate_user_reducer = ReducerFunctions(UpdateDelegateUser, {});